<template>
  <v-col>
    <v-card>
      <v-card-title>Dev Tools</v-card-title>
      <v-card-text>
        This is the Dev Tools view.
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'DevTools',
}
</script>
